import { RESET_STATE } from "components/curb/ManagerAnalyzer/Toggle/commonUtilities";
import {} from "../../actions/regulation/CreateRegulation/types";
import {
    RegulationTemplatesState,
    RegulationTemplatesTypes,
    REGULATION_TEMPLATES_RECEIVED,
    SET_TEMPLATES_REGULATION_DATA,
    SET_TEMPLATES_RESTRICTIONS_DATA
} from "../../actions/regulation/regulationTemplates/types";

const initialState: RegulationTemplatesState = {
    templates: {
        meta: {
            count: 0,
            previous: null,
            next: null
        },
        results: []
    },
    templatesRegulationData: {},
    templatesRestrictionsData: []
};
const CreateRegulation = (
    state = initialState,
    action: RegulationTemplatesTypes
): RegulationTemplatesState => {
    switch (action.type) {
        case REGULATION_TEMPLATES_RECEIVED: {
            return {
                ...state,
                templates: action.payload.data
            };
        }
        case SET_TEMPLATES_RESTRICTIONS_DATA: {
            return {
                ...state,
                templatesRestrictionsData: action.payload.data
            };
        }
        case SET_TEMPLATES_REGULATION_DATA: {
            return {
                ...state,
                templatesRegulationData: action.payload.data
            };
        }
        case RESET_STATE: {
            return {
                ...initialState
            };
        }
        default: {
            return {
                ...state
            };
        }
    }
};

export default CreateRegulation;
